const init = () => {
    if (window.scrollY > 150 || document.getElementById('discussion-box')) {
        window.removeEventListener('scroll', init)

        fetch('https://d.seznam.cz/recass/js/sznrecommend.min.js')
            .then((response) => response.text())
            .then((text) => eval(text))
            .then(() => {
                sznRecass.getRecommendationsByTags()
            })
    }
}

if (document.querySelector('[data-szn-recass-box]')) {
    // Lazy load after 150px scroll
    window.addEventListener('scroll', init)

    init()
}

const loadSeznamRecommendMeasure = () => {
    let scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', 'https://d.seznam.cz/recass/js/sznrecommend-measure.min.js')
    scriptTag.setAttribute('defer', 'defer')
    scriptTag.setAttribute('data-webid', window.themeConfig.seznamWebId)
    document.body.appendChild(scriptTag)
}

document.addEventListener('DOMContentLoaded', function () {
    loadSeznamRecommendMeasure()
})